<div class="w-100 mt-0 tool-container">
  <h4>Delete Products</h4>
  <mat-form-field class="me-3">
    <mat-label>Table Name</mat-label>
    <mat-select [(ngModel)]="deleteLifeProducts.table">
      @for (opt of lifeProductTables; track opt) {
        <mat-option [value]="opt">
          {{ opt.display }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Column to Match</mat-label>
    <input matInput [(ngModel)]="deleteLifeProducts.column" />
  </mat-form-field>
  <span class="file-container">
    <input
      type="file"
      class="file-input"
      (change)="onFileSelected($event)"
      #fileDelete
    />

    <span class="file-upload">
      {{ deleteFileName || 'No file selected yet' }}

      <button
        mat-mini-fab
        color="primary"
        class="upload-btn"
        (click)="fileDelete.click()"
      >
        <mat-icon>attach_file</mat-icon>
      </button>
    </span>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="deleteLifeProduct()"
    [disabled]="!deleteLifeProducts.table || !deleteFile"
  >
    Delete
  </button>
  @if (deleteLifeProducts.status) {
    <h4 class="col-12 {{ deleteLifeProducts.statusClass }}">
      {{ deleteLifeProducts.status }}
    </h4>
  }
</div>
